import { SubsRepository, type SubcontractSortKey, type SubcontractStatus } from "@/repositories/subs.repository";
import { ServicesRepository } from "@/repositories/services.repository";
import { uuid } from "@/interfaces";
import type { SubcontractContactRequest } from "@shyne/shared/api";

export async function searchSubs(
  page: number = 1,
  pageSize: number = 10,
  name?: string,
  service?: string,
  sortKey: SubcontractSortKey = "name",
  sortOrder: "asc" | "desc" = "asc",
  status: SubcontractStatus = "live"
) {
  return SubsRepository.listByCurrentOrg(page, pageSize, name, service, sortKey, sortOrder, status);
}

export async function searchSubcontractors(query: string) {
  return SubsRepository.searchSubcontractors(query);
}

export async function removeSubsFromOrg(orgSubsId: uuid) {
  return SubsRepository.remove(orgSubsId);
}

export async function addExistingSubs(organizationId: uuid) {
  return SubsRepository.addExistingSubs(organizationId);
}

export async function inviteSubs(email: string, services: uuid[] = []) {
  return SubsRepository.inviteSubs(email, services);
}

export async function updateSubsServices(orgSubsId: uuid, services: uuid[]) {
  return SubsRepository.setServices(orgSubsId, services);
}

export async function getSubsDetail(orgSubsId: uuid) {
  return SubsRepository.getDetail(orgSubsId);
}

export async function uploadSubsDocument(subcontractId: uuid, file: File, expiresAt?: string | Date) {
  return SubsRepository.uploadDocument(subcontractId, file, expiresAt);
}

export async function deleteSubsDocument(docId: uuid) {
  return SubsRepository.deleteDocument(docId);
}

export async function updateSubsDocumentExpiresAt(docId: uuid, expiresAt: string | Date | null) {
  return SubsRepository.updateDocumentExpiresAt(docId, expiresAt);
}

export async function listSubsDocuments(orgSubsId: uuid, page = 1, pageSize = 10) {
  return SubsRepository.listDocuments(orgSubsId, page, pageSize);
}

export async function getAvailableServices() {
  return ServicesRepository.getParentServices();
}

export async function updatePrimaryContact(orgSubsId: uuid, contact: SubcontractContactRequest) {
  return SubsRepository.setContact(orgSubsId, contact);
}
